import { createContext, PropsWithChildren, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  Game,
  LeaderboardConfiguration,
  ProjectPublic,
  ProjectStatus,
  CustomEndScreenConfiguration,
} from "../gql/graphql";

export interface GlobalConfigurationContextType {
  isPreviewMode: boolean;
  hideDatagameBranding: boolean;
  hideSummaryPage: boolean;
  showLeaderboard: boolean;
  showCustomEndScreen: boolean;
  customEndScreenConfiguration?: CustomEndScreenConfiguration | null;
  leaderboardConfiguration: LeaderboardConfiguration;
  games: Game[];
  projectNickname: string;
  setProjectNickname: (nickname: string) => void;
  projectId: string;
}

export interface GlobalConfigurationProviderProps extends PropsWithChildren {
  configuration: ProjectPublic;
}

export const GlobalConfigurationContext = createContext<GlobalConfigurationContextType | undefined>(undefined);

export const GlobalConfigurationProvider = ({ children, configuration }: GlobalConfigurationProviderProps) => {
  const [searchParams] = useSearchParams();
  const isLive = configuration.status === ProjectStatus.Live;
  const isPreviewMode = searchParams.get("preview") === "true" || !isLive;
  const [projectNickname, setProjectNickname] = useState<string>("");

  return (
    <GlobalConfigurationContext.Provider
      value={{
        isPreviewMode,
        games: configuration.games,
        hideDatagameBranding: configuration.hideDatagameBranding,
        hideSummaryPage: configuration.hideSummaryPage,
        showLeaderboard: configuration.showLeaderboard,
        showCustomEndScreen: configuration.showCustomEndScreen,
        customEndScreenConfiguration: configuration.customEndScreenConfiguration,
        leaderboardConfiguration: configuration.leaderboardConfiguration,
        projectNickname,
        setProjectNickname,
        projectId: configuration.id,
      }}
    >
      {children}
    </GlobalConfigurationContext.Provider>
  );
};
